var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;var _id=_interopRequireDefault(require("@24i/nxg-sdk-smartott/src/pages/player/[type]/[id]"));var _default=

_id.default;exports.default=_default;